(() => {
  if (customElements.get('bm-tiktok-videos')) return;
  let active = null;
  class BlackmaskVideos extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.bm-videos__track');
      const nav = this.querySelector('.bm-videos__nav');
      if (!track || !nav) return;
      const events = new AbortController();
      const options = { signal: events.signal };
      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        nav.hidden = max < 4;
        nav.querySelector('[data-direction="-1"]').disabled = track.scrollLeft <= 2;
        nav.querySelector('[data-direction="1"]').disabled = track.scrollLeft >= max - 2;
      };
      this.addEventListener('click', event => {
        const link = event.target.closest('.bm-videos__play');
        if (link && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
          const id = link.dataset.videoId;
          const hosted = link.dataset.hosted === 'true';
          if (!hosted && !/^\d{15,22}$/.test(id)) return;
          event.preventDefault();
          active?.stop(false);
          const stage = link.closest('.bm-videos__stage');
          const player = stage.querySelector('.bm-videos__inline-player');
          const stopButton = stage.querySelector('.bm-videos__stop');
          const media = document.createElement(hosted ? 'video' : 'iframe');
          media.title = link.dataset.videoTitle;
          if (hosted) {
            media.controls = true;
            media.playsInline = true;
            media.autoplay = true;
            media.src = link.href;
          } else {
            media.allow = 'autoplay; fullscreen; encrypted-media; picture-in-picture';
            media.allowFullscreen = true;
            media.src = `https://www.tiktok.com/player/v1/${id}?autoplay=1&loop=0&rel=0`;
          }
          link.hidden = true;
          player.hidden = false;
          stopButton.hidden = false;
          player.replaceChildren(media);
          active = { section: this, stop: (focus = true) => {
            if (hosted) { media.pause(); media.removeAttribute('src'); media.load(); }
            player.replaceChildren();
            player.hidden = true;
            stopButton.hidden = true;
            link.hidden = false;
            active = null;
            if (focus) link.focus({preventScroll:true});
          }};
          stopButton.focus({preventScroll:true});
        }
        if (event.target.closest('.bm-videos__stop')) active?.stop();
        const arrow = event.target.closest('[data-direction]');
        if (arrow) track.scrollBy({left:Number(arrow.dataset.direction)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && active?.section === this) active.stop();
      }, options);
      track.addEventListener('scroll', update, {...options,passive:true});
      const observer = new ResizeObserver(update);
      observer.observe(track);
      update();
      this.cleanup = () => {
        if (active?.section === this) active.stop(false);
        events.abort();
        observer.disconnect();
        this.cleanup = null;
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  }
  customElements.define('bm-tiktok-videos', BlackmaskVideos);
})();
